import React from 'react';
import PropTypes from 'prop-types';
import Link from '@decisiv/ui-components/lib/components/Link';
import { P } from '@decisiv/ui-components/lib/components/Typography';

const LinkOrLabel = ({ count, to, text }) => (
  <P weight="medium">
    {count > 0 ? (
      <Link to={to} text={text} />
    ) : (
      <P as="span" shade={1}>
        {text}
      </P>
    )}
  </P>
);

LinkOrLabel.propTypes = {
  count: PropTypes.number,
  to: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

LinkOrLabel.defaultProps = {
  count: 0,
};

export default LinkOrLabel;
